module.exports = __webpack_public_path__ + "img/crown.83699364.svg";